import api from './'

export default {

    /**
     * Get bookings of partner
     * @param partnerId
     * @param params
     */
    getBookings(partnerId, params = {}) {
        return api
            .get(`/partners/${partnerId}/bookings`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get card transactions
     * @param partnerId
     * @param params
     */
    getCardTransactions(partnerId, params = {}) {
        return api
            .get(`/partners/${partnerId}/cardTransactions`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get card authorizations
     * @param partnerId
     * @param params
     */
    getCardAuthorizations(partnerId, params = {}) {
        return api
            .get(`/partners/${partnerId}/cardAuthorizations`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get config
     * @param partnerId
     * @param key
     * @param params
     */
    getModuleConfig(partnerId, key, params) {
        return api
            .get(`/partners/${partnerId}/configs/${key}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Set config
     * @param partnerId
     * @param key
     * @param data
     */
    setModuleConfig(partnerId, key, data) {
        return api
            .post(`/partners/${partnerId}/configs/${key}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Disable config
     * @param partnerId
     * @param key
     * @param data
     */
    disableModuleConfig(partnerId, key, data) {
        return api
            .post(`/partners/${partnerId}/configs/${key}/disable`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get statistics
     * @param partnerId
     * @param params
     */
    getStats(partnerId, params) {
        return api
            .get(`/partners/${partnerId}/stats`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Get users with access to partners
     * @param partnerId
     * @param params
     */
    getUsers(partnerId, params = {}) {
        return api
            .get(`/partners/${partnerId}/users`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Give user access to partner
     * @param partnerId
     */
    giveAccessToPartner(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/users/giveAccess`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Remove user access to partner
     * @param partnerId
     */
    removeAccessToPartner(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/users/removeAccess`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Get list of partners
     * @param params
     */
    get(params) {
        return api
            .get(`/partners`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create partner
     * @param data
     */
    create(data) {
        return api
            .post(`/partners`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show a partner
     * @param partnerId
     * @param params
     */
    show(partnerId, params) {
        return api
            .get(`/partners/${partnerId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update a partner
     * @param partnerId
     * @param data
     */
    update(partnerId, data) {
        return api
            .put(`/partners/${partnerId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete partner
     * @param partnerId
     */
    delete(partnerId) {
        return api
            .delete(`/partners/${partnerId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Add a media partner
     * @param partnerId
     * @param data
     */
    addMedia(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/medias`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Accept invite to manage a partner
     * @param params
     * @param data
     */
    acceptInvite(params, data) {
        return api
            .post(`/partners/acceptInvite`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get addresses
     * @param partnerId
     * @param params
     */
    getAddresses(partnerId, params) {
        return api
            .get(`/partners/${partnerId}/addresses`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Add a contact
     * @param partnerId
     * @param data
     */
    addContact(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/contacts`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Enable partner
     * @param partnerId
     * @param data
     */
    enable(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/enable`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Disable partner
     * @param partnerId
     * @param data
     */
    disable(partnerId, data) {
        return api
            .post(`/partners/${partnerId}/disable`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Get pending bookings
     * @param partnerId
     */
    getPendingBookings(partnerId) {
        return this.getBookings(partnerId, { status : 'pending' })
    },

    /**
     * Get non-pending bookings
     * @param partnerId
     */
    getResolvedBookings(partnerId) {
        return this.getBookings(partnerId, { statuses : [ 'confirmed', 'declined', 'cancelled' ] })
    },

    /**
     * Suggest partner
     * @param data
     */
    suggest(data) {
        return api
            .post(`/partners/suggest`, data)
            .then(response => {
                return response.data
            });
    },

}
